import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { TASK_STATUS } from '../../lib/schema.js';

TaskStatusFilter.defaultProps = {
  selectedTaskStatuses: [],
};

function TaskStatusFilter({ selectedTaskStatuses, navigateAction }) {
  const selectedCount = selectedTaskStatuses.length;

  const handleSelect = useCallback(
    (taskStatus) =>
      navigateAction({
        taskStatuses: taskStatus ? xor(selectedTaskStatuses, [taskStatus]) : [],
      }),
    [selectedTaskStatuses]
  );

  const renderMenuItem = useCallback(
    (taskStatus) => (
      <React.Fragment key={taskStatus}>
        <MenuItem
          active={selectedTaskStatuses.includes(taskStatus)}
          eventKey={taskStatus}
          onSelect={handleSelect}
        >
          {taskStatus}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedTaskStatuses]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Task Status</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="task-status-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {TASK_STATUS.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default TaskStatusFilter;
